import { render, staticRenderFns } from "./PrizesWinnersTable.vue?vue&type=template&id=3f2428d6&scoped=true"
import script from "./PrizesWinnersTable.vue?vue&type=script&lang=js"
export * from "./PrizesWinnersTable.vue?vue&type=script&lang=js"
import style0 from "./PrizesWinnersTable.vue?vue&type=style&index=0&id=3f2428d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2428d6",
  null
  
)

export default component.exports